import { setItem } from 'owa-local-storage';
import {
    TRY_SUGGESTION_DISPLAY_COUNT_STRING,
    TRY_SUGGESTION_CLICK_COUNT_STRING,
    TRY_SUGGESTION_IDS_STRING,
} from '../searchConstants';
import { TrySuggestionCountType } from '../store/schema/TrySuggestionCountType';

export function setTrySuggestionsCount(SuggestionCountType: TrySuggestionCountType, value: number) {
    let key;
    switch (SuggestionCountType) {
        case TrySuggestionCountType.Display:
            key = TRY_SUGGESTION_DISPLAY_COUNT_STRING;
            break;
        case TrySuggestionCountType.Click:
            key = TRY_SUGGESTION_CLICK_COUNT_STRING;
            break;
    }
    setItem(window, key, value.toString());
}

export function setExcludedTrySuggestionIds(value: string) {
    setItem(window, TRY_SUGGESTION_IDS_STRING, value);
}
